import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ProAgeFormat",
  props: {},
  emits: [],
  components: {},
  setup() {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      content: "proAge/content",
      tickets: "proAge/tickets",
      isAuthenticated: "auth/isAuthenticated",
    }),
  },
  methods: {
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      addWebinarToBasket: "basket/ADD_WEBINAR_ITEM_TO_BASKET",
      changeBasketPopup: "basket/SHOW_BASKET_POPUP",
      changeSeminarInfo: "popups/SHOW_SEMINAR_INFO_POPUP",
      setSeminarInfoContent: "popups/SET_SEMINAR_INFO_CONTENT",
    }),
    buyTicket(product) {
      if (!this.isAuthenticated) {
        this.showSeminarInfoPopup(
          "",
          "<p style='text-align: center; font-size: 18px; margin-top: 20px;'>Дане навчання доступне лише для авторизованих користувачів. Будь ласка, увійдіть у свій особистий кабінет</p>"
        );
        return;
      }
      const productPrices = { ...product.productPrices.data[0] };
      productPrices.quantity = 1;
      productPrices.price = productPrices.basePrice;
      this.addWebinarToBasket({
        select_count: 1,
        product,
        product_price: productPrices,
      });
      this.changeBasketPopup(true);
      this.checkCoursesInBasket(product.id);
      this.$toasted.success("Квиток успішно додано в кошик");
    },
    showSeminarInfoPopup(title, description) {
      this.changeSeminarInfo(true);
      this.setSeminarInfoContent({ title: title, description: description });
    },
  },
};
